import { Env, readFromEnv } from "@cinch-nx/environments";
import { setTag, tagError, traceFunction } from "@core/datadog-server";
import { getStoryBySlug } from "@cinch-nx/data-storyblok";
import { generateStoreNameWithType } from "@cinch-nx/landing-ui-shared";
export const VEHICLE_SEARCH_URL = `${readFromEnv(Env.SearchServiceUrl)}/vehicles`;
const formatHeroAddress = (address)=>`${address.addressLine1}, ${address.addressLine2}, ${address.townOrCity}, ${address.postCode}`;
export const getStaticPropsfn = async ({ params , preview =false  })=>{
    const storeName = params === null || params === void 0 ? void 0 : params.slug;
    try {
        const story = await getStoryBySlug(`store/${storeName}`, {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Store information story not found");
        }
        let storeVehicles = [];
        try {
            const response = await fetch(`${readFromEnv(Env.SearchServiceUrl)}/vehicles?store=${storeName}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch vehicles: ${response.statusText}`);
            }
            const { vehicleListings  } = await response.json();
            storeVehicles = vehicleListings.length < 9 ? vehicleListings : vehicleListings.slice(0, 9);
        } catch (error) {
            if (error instanceof Error || typeof error === "string") {
                tagError(error);
            }
            storeVehicles = [];
        }
        setTag("response.code", 200);
        setTag("page.rendered", "ISR");
        setTag("page.revalidate-in", "60s");
        setTag("page.name", `store/${storeName}`);
        setTag("page.params", JSON.stringify({
            preview,
            storeVehicles
        }, null, 2));
        setTag("page.response-code", "200");
        const title = generateStoreNameWithType(storeName, true);
        const heroProps = {
            ...story.content.storeHero[0],
            title,
            address: formatHeroAddress(story.content.address[0]),
            telephoneNumber: story.content.phoneNumbers[0].phoneNumber
        };
        return {
            props: {
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    showBorderRadius: true,
                    heroProps
                },
                storeVehicles
            },
            revalidate: 60
        };
    } catch (error1) {
        if (typeof error1 === "string" || error1 instanceof Error) {
            console.log(error1);
        }
        return {
            notFound: true
        };
    }
};
export const getStaticProps = traceFunction("store-page.getStaticProps", getStaticPropsfn);
